module.exports = __webpack_public_path__ + "static/media/297523.91279a36.png";